import { useState } from 'react';
import contract from '~/assets/icons/contract.svg';
import sort from '~/assets/icons/sort.svg';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { SectionHeading } from '~/components/ui/SectionHeading';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { AppTruckJobActiveContract } from '../AppTruckJobActiveContract';
import { AppTruckJobActiveOrder } from '../AppTruckJobActiveOrder';
import { AppTruckJobContractBig } from '../AppTruckJobContractBig';
import { AppTruckJobMyLevel } from '../AppTruckJobMyLevel';
import { AppTruckJobOrderItem } from '../AppTruckJobOrderItem';
import { Select } from '../Select';
import { filterSelectItems } from './AppTruckJobMyOrders.model';
import {
	StyledActiveContractHeadingContainer,
	StyledActiveContractHeadingLeft,
	StyledActiveOrderContainer,
	StyledAllContractsContainer,
	StyledContainer,
	StyledHeader,
	StyledHeadTitleContainer,
	StyledLeftContainer,
	StyledNotActiveContactHeading,
	StyledOrdersContainer,
	StyledRightContainer,
} from './AppTruckJobMyOrders.styled';

const AppTruckJobMyOrders = () => {
	// TODO: add sdk
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const activeContract = true;
	// TODO: add sdk
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const activeStatus = false;
	const [sortValue, setSortValue] = useState<string | number | null>(null);

	return (
		<StyledContainer $isActiveContract={activeContract}>
			<StyledLeftContainer $isActiveContract={activeContract}>
				<StyledHeader>
					<StyledHeadTitleContainer>
						<img src={contract} />
						<Text>
							{activeContract ? 'Активный контракт' : 'Мои контракты'}
						</Text>
					</StyledHeadTitleContainer>
					{!activeContract && (
						<Select
							icon={sort}
							items={filterSelectItems}
							value={sortValue}
							placeholder={'Сортировать'}
							onChange={(value) => setSortValue(value.value)}
							style={{ width: 240 }}
						/>
					)}
				</StyledHeader>
				<StyledActiveOrderContainer>
					{activeContract ? (
						<AppTruckJobActiveContract />
					) : (
						<AppTruckJobMyLevel />
					)}
				</StyledActiveOrderContainer>
				{/* {activeContract && (
				<StyledProgressContainer>
					<StyledTimerContainer>
						<img src={clock} />
						<Text>02:44</Text>
					</StyledTimerContainer>
					<div className="dividers">
						<Divider
							$direction="V"
							$color={'#000000'}
							style={{ opacity: 0.5 }}
						/>
						<Divider $direction="V" style={{ opacity: 0.1 }} />
					</div>
					<div>
						<Text style={{ fontSize: 12, color: '#ffffff', opacity: 0.5 }}>
							Выполнено заказов
						</Text>
						<Text
							style={{
								fontSize: 14,
								fontWeight: 500,
								color: '#ffffff',
								marginTop: 6,
							}}
						>
							20{' '}
							<span style={{ fontSize: 12, fontWeight: 400, opacity: 0.5 }}>
								/ 40 поездок
							</span>
						</Text>
					</div>
					<div className="dividers">
						<Divider
							$direction="V"
							$color={'#000000'}
							style={{ opacity: 0.5 }}
						/>
						<Divider $direction="V" style={{ opacity: 0.1 }} />
					</div>
					<div>
						<Text style={{ fontSize: 12, color: '#ffffff', opacity: 0.5 }}>
							Бонус за скорость
						</Text>
						<StyledPriceExpContainer>
							<StyledRubleGreen
								style={{
									maskImage: `url(${rubleIcon})`,
									WebkitMaskImage: `url(${rubleIcon})`,
								}}
							/>
							<Text style={{ color: '#1AB248', marginLeft: 6 }}>20 000</Text>
							<Text style={{ color: '#ffffff', marginLeft: 10 }}>+ 500XP</Text>
						</StyledPriceExpContainer>
					</div>
					<StyledStatusContainer>
						<StyledStatus $isActive={activeStatus}>
							<Text>{activeStatus ? 'В процессе' : 'Не начато'}</Text>
						</StyledStatus>
						<StyledStatusProgressSvg>
							<circle
								cx="15"
								cy="15"
								r="10.5"
								stroke="#ffffff"
								strokeWidth="4"
								fill="none"
								opacity={0.1}
							/>
							<circle
								cx="15"
								cy="15"
								r="10.5"
								className="indicator"
								stroke="#1AB248"
								strokeWidth="4"
								fill="none"
								strokeLinecap="round"
								strokeDasharray={65.97}
								strokeDashoffset={20}
							/>
						</StyledStatusProgressSvg>
					</StyledStatusContainer>
				</StyledProgressContainer>
			)} */}
				{activeContract && (
					<div style={{ marginTop: 20 }}>
						<StyledActiveContractHeadingContainer>
							<SectionHeading
								text={'Заказы'}
								icon={contract}
								gap={10}
								iconSize={20}
								fontSize={16}
							/>
							<StyledActiveContractHeadingLeft>
								<Text>
									Осталось <span>2</span> / 10
								</Text>
							</StyledActiveContractHeadingLeft>
						</StyledActiveContractHeadingContainer>
						<ScrollContainer
							height={389}
							scrollbarHeight={369}
							style={{ marginTop: 20 }}
							showMask
						>
							<StyledOrdersContainer>
								{new Array(10).fill(0).map((_, index) => (
									<AppTruckJobOrderItem
										key={index}
										level={((index + 1) % 4) + 1}
									/>
								))}
							</StyledOrdersContainer>
						</ScrollContainer>
					</div>
				)}
				{!activeContract && (
					<div style={{ marginTop: 30 }}>
						<StyledNotActiveContactHeading>
							<SectionHeading
								text={'Доступные контракты'}
								icon={contract}
								gap={10}
								iconSize={20}
								fontSize={16}
							/>
							<Text style={{ fontSize: 16, color: 'rgba(255, 255, 255, 0.5)' }}>
								Задачи обновятся через{' '}
								<span style={{ fontWeight: 500, color: '#FABE2C' }}>
									00:00:00
								</span>
							</Text>
						</StyledNotActiveContactHeading>
						<StyledAllContractsContainer>
							{new Array(10).fill(0).map((_, index) => (
								<AppTruckJobContractBig key={index} />
							))}
						</StyledAllContractsContainer>
					</div>
				)}
			</StyledLeftContainer>
			{activeContract && (
				<StyledRightContainer>
					<AppTruckJobActiveOrder />
				</StyledRightContainer>
			)}
		</StyledContainer>
	);
};

export { AppTruckJobMyOrders };
